// extracted by mini-css-extract-plugin
export default {"clockCount":"ClockCount_clockCount__LaCNd"};